import * as React from 'react'
import { config } from 'react-awesome-styled-grid'
import { FadeInImage } from '@components/shared/FadeInImage'
import Link from 'next/link'
import { convertCreatorByIdToProps, convertCreatorBySlugToProps } from '../../models/Creator'
import type { CreatorInfoPropsType, CreatorPropsType } from '../../models/Creator'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import { colors, GoodSansB1 } from '@components/shared'

export function CreatorListItemComponent (props: CreatorInfoPropsType): React.ReactNode {
  const {
    title,
    imageUrl,
    logLine,
    episodeInfo,
    slug
  } = props
  const router = useRouter()
  const click = (): void => {
    router.push(slug)
  }
  return (
      <CreatorContainer onClick={click}>
        <ImageContainer><FadeInImage width={200} height={200} src={imageUrl}/></ImageContainer>
        <CreatorInfoContainer>
          <TitleContainer><Link passHref href={slug}>{title}</Link></TitleContainer>
          <DescriptionContainer>{logLine}</DescriptionContainer>
          <EpisodeInfoContainer>{episodeInfo}</EpisodeInfoContainer>
        </CreatorInfoContainer>
      </CreatorContainer>
  )
}

const EpisodeInfoContainer = styled.div<any>`
    font-family: "Good Sans Regular";
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%; /* 136.364% */
    letter-spacing: -0.3px;
    color: ${colors.white};
    margin: 10px 0px;
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
    font-size: 16px;
    line-height: 150%; /* 136.364% */
  `}
`

const DescriptionContainer = styled.div<any>`
    font-family: "Good Sans Regular";
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%; /* 136.364% */
    letter-spacing: -0.3px;
    color: ${colors.white70};
    margin: 10px 0px;
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
    font-size: 16px;
    line-height: 150%; /* 136.364% */
  `}
`
const TitleContainer = styled.div<any>`
    a {
        font-family: "Good Sans Regular";
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: -0.3px;
        color: ${colors.white};
        text-decoration: none;
    }
          ${(props: any): any => config(props).media.xs`
  `}
        ${(props: any): any => config(props).media.sm`
  `}
        ${(props: any): any => config(props).media.md`
        a {
          font-size: 18px;
          }
        `}
        ${(props: any): any => config(props).media.lg`
  `}
        ${(props: any): any => config(props).media.xl`
  `}
`
const CreatorContainer = styled.div<any>`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 0;
    width: 100%;
  ${(props: any): any => config(props).media.xs`
  `}
  ${(props: any): any => config(props).media.sm`
  `}
  ${(props: any): any => config(props).media.md`
    padding: 32px 0;
    border-bottom: 0.5px solid ${colors.white70}
  `}
  ${(props: any): any => config(props).media.lg`
  `}
  ${(props: any): any => config(props).media.xl`
  `}
`

const ImageContainer = styled.div<any>`
    width: 100px;
    height: 100px;
    flex-shrink: 0;
    margin-right: 16px;
    img {
        border-radius: 100px;
    }
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
    width: 134px;
    height: 134px;
  `}
    ${(props: any): any => config(props).media.md`
    width: 187px;
    height: 187px;
    margin-right: 24px;
  `}
    ${(props: any): any => config(props).media.lg`
    margin-right: 48px;
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`
const CreatorInfoContainer = styled.div<any>`
    ${GoodSansB1};
    ${(props: any): any => config(props).media.xs`
  `}
    ${(props: any): any => config(props).media.sm`
  `}
    ${(props: any): any => config(props).media.md`
  `}
    ${(props: any): any => config(props).media.lg`
  `}
    ${(props: any): any => config(props).media.xl`
  `}
`
export function CreatorListItem (props: { id: string, type: 'slug' | 'id' }): React.ReactNode {
  const [creator, setCreator] = React.useState<any>(null)
  React.useEffect((): void => {
    if (props.type === 'id') {
      convertCreatorByIdToProps(props.id).then((creatorItem: CreatorPropsType): void => {
        setCreator(creatorItem)
      })
    } else {
      convertCreatorBySlugToProps(props.id).then((creatorItem: CreatorPropsType): void => {
        setCreator(creatorItem)
      })
    }
  }, [props.id])
  if (creator) {
    return <CreatorListItemComponent {...creator} />
  }
  return null
}
